import React from 'react';
import { Redirect } from 'react-router-dom';

const ManagerDashboardRedirect = () => <Redirect to="/reports/network-panel" />;

export default ManagerDashboardRedirect;
